// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"346":"stores","486":"orders","818":"auth"}[chunkId] || chunkId) + "." + {"15":"21180802","346":"a18f9992","486":"f0fcb2f3","818":"a8ef257a"}[chunkId] + ".css";
};